import React from 'react';
import PropTypes from 'prop-types';

import EditableText from './EditableText';
import EmailPreview from './EmailPreview';
import { subjectInputId } from '../constants';

const QuickUpdateEmailPreview = ({
  backgroundImage,
  color,
  logo,
  message,
  onMessageChange,
  onSubjectChange,
  shopAddress,
  shopName,
  subject,
  editable,
  onSubjectClick,
}) => (
  <EmailPreview
    {...{
      backgroundImage,
      color,
      logo,
      shopAddress,
      shopName,
      editable,
      onSubjectChange,
      subject,
      onSubjectClick,
    }}
  >
    <div className="beta u-mb- u-type--normal">
      <EditableText
        defaultText="Click to Edit"
        value={subject}
        onChange={onSubjectChange}
        editable={editable}
        id={subjectInputId}
      />
    </div>
    <EditableText value={message} onChange={onMessageChange} editable={editable} />
  </EmailPreview>
);
QuickUpdateEmailPreview.propTypes = {
  message: PropTypes.string,
  onMessageChange: PropTypes.func.isRequired,
  onSubjectChange: PropTypes.func.isRequired,
  onSubjectClick: PropTypes.func.isRequired,
  shopAddress: PropTypes.shape({
    street: PropTypes.string,
    street2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
  }).isRequired,
  shopName: PropTypes.string.isRequired,
  subject: PropTypes.string,
  backgroundImage: PropTypes.string,
  color: PropTypes.string,
  logo: PropTypes.string,
  editable: PropTypes.bool,
};
QuickUpdateEmailPreview.defaultProps = {
  message: '',
  subject: '',
  backgroundImage: '',
  color: '#4d4d4d',
  logo: '',
  editable: true,
};

export default QuickUpdateEmailPreview;
